import React from 'react'
import colors from '../../../Colors.scss'

const NoVideo = ({ width = '24', height = '24', color = colors.color_sidebar_icon }) => {
  return (
        <svg
            width={width}
            height={height}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 32 32"
            fill={color}
        >
            <g data-name="Layer 57">
                <path
                    d="M16,31A15,15,0,1,1,31,16,15,15,0,0,1,16,31ZM16,3A13,13,0,1,0,29,16,13,13,0,0,0,16,3Z"
                    fill={color}
                />
                <path
                    d="M16 24a2 2 0 1 1 2-2A2 2 0 0 1 16 24zm0-2zM16 18a1 1 0 0 1-1-1V8a1 1 0 0 1 2 0v9A1 1 0 0 1 16 18z"
                    fill={color}
                />
            </g>
        </svg>
  )
}

export default NoVideo
